<template>
  <div class="custom-container" v-loading.fullscreen.lock="user.isLoading">
    <el-row>
      <el-row type="flex" align="center" class="my-4" justify="space-between">
        <el-col :span="5">
          <div class="category-title">Create Staff Account</div>
        </el-col>
        <el-col :span="4">
          <el-row type="flex" justify="end">
            <el-button size="small" @click="$router.go(-1)">Kembali</el-button>
            <el-button size="small" type="primary" @click="save">Simpan</el-button>
          </el-row>
        </el-col>
      </el-row>

      <el-col :span="24">
        <el-form
          label-width="120px"
          label-position="left"
          ref="adminandstaff"
          :model="adminandstaff"
        >
          <Form :AdminAndStaff="adminandstaff"></Form>
        </el-form>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import Form from "./Form";
import { mapActions, mapState } from "vuex";
export default {
  components: {
    Form
  },
  data: () => ({
    adminandstaff: {
      username: "",
      password: "",
      fullname: "",
      jobTitle: "",
      roleId: 2,
      branchCode: "",
      isActive: true,
      userCreated: "",
      email: "",
      userType: "",
      primarySalesrepId: null
    },
    valid: true,
    draft: false
  }),
  computed: {
    ...mapState({
      user: state => state.user.adminOrStaff
    })
  },
  methods: {
    ...mapActions({
      createUser: "user/CreateUser"
    }),
    save() {
      this.$refs.adminandstaff.validate(valid => {
        const userCreated = JSON.parse(localStorage.getItem("user"));
        this.adminandstaff.userCreated = userCreated.fullname;
        if (this.adminandstaff.userType === 'sales') {
          this.adminandstaff.roleId = 4
        } else if (this.adminandstaff.userType === 'driver') {
          this.adminandstaff.roleId = 5
        } else if (this.adminandstaff.userType === 'management') {
          this.adminandstaff.roleId = 3
        }
        if (valid) {
          this.createUser(this.adminandstaff);
          this.snackbar = true;
        } else {
          return false;
        }
      });
    }
  }
};
</script>

<style>
</style>
